<template>
  <div @click="editAddress()">
    <small class="label">{{ $l.userAddress }}</small>
    <input
      type="text"
      class="input-text with-label"
      v-model="$store.getters['user/address']"
      disabled
      :placeholder="$l.userAddress"
      >
  </div>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  methods: {
    editAddress: function () {
      this.$store.dispatch('popup/show', 'user-address')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './_input.scss';
</style>
